import React from 'react'
import { Colors } from '../../design/Colors'
import { Fonts } from '../../design/Font'

export default class LinkedText extends React.Component{

    render(){
        const {title, onClick, align} = this.props
        return(
            <div style={{display:'flex', width:"100%", justifyContent:align}}>
                <span onClick={onClick} style={{...Fonts.subtext, cursor:'pointer', textAlign:align,color:Colors.light_blue,alignSelf:'center', textDecoration:'underline'}}>{title}</span>
            </div>
        )
    }
}